import React from 'react';
import { Headphones } from 'lucide-react';
import { CONTACT_TELEGRAM_URL } from '../../config/brand';

const SUPPORT_MESSAGE = 'لو قابلتلك مشكلة .. احنا معاك';

interface SupportTelegramFabProps {
  /** Extra classes on the fixed wrapper (e.g. position offset) */
  className?: string;
}

/**
 * Floating technical-support button — opens Telegram for 01023483013.
 */
const SupportTelegramFab: React.FC<SupportTelegramFabProps> = ({ className = '' }) => {
  const handleOpen = () => {
    window.open(CONTACT_TELEGRAM_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className={`fixed bottom-5 left-4 z-40 flex max-w-[calc(100vw-1.5rem)] items-end gap-2.5 sm:bottom-6 sm:left-6 sm:gap-3 ${className}`}
      dir="rtl"
    >
      <div className="relative hidden max-w-[11.5rem] rounded-2xl border border-green-100 bg-white p-3 shadow-xl min-[380px]:block sm:max-w-64 sm:p-4">
        <p className="text-[11px] font-bold leading-relaxed text-green-900 sm:text-xs">الدعم الفني</p>
        <p className="mt-1 text-[11px] font-medium leading-relaxed text-gray-700 sm:text-xs">
          {SUPPORT_MESSAGE}
        </p>
      </div>

      <button
        type="button"
        onClick={handleOpen}
        className="group relative flex min-h-12 min-w-12 shrink-0 items-center justify-center rounded-full bg-green-700 p-3.5 text-white shadow-2xl transition-all duration-300 hover:scale-110 hover:bg-green-800 sm:min-h-14 sm:min-w-14 sm:p-4"
        aria-label="الدعم الفني"
        title="الدعم الفني"
      >
        <Headphones className="h-6 w-6 sm:h-7 sm:w-7" strokeWidth={2.25} aria-hidden />
        <span className="absolute inset-0 animate-ping rounded-full bg-green-600 opacity-20" />
      </button>
    </div>
  );
};

export default SupportTelegramFab;
